import { IMyQuestionItem, IProjectItem } from '@/sub-luca-plugin/types';
import Http from '@/sub-luca-plugin/utils/http';
import { IPageResponse } from '@/types';

// 获取收藏列表项目科目
export const query_projects_of_collects = (params: {
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number; // 二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
}) => Http.get<IProjectItem[]>('/athena/api/v1/front/luca-ask/collect/project/subject/list', params);

// 获取收藏列表
export const query_collects = (params: {
    projectId?: number; // 项目id
    subjectId?: number; // 科目id
    twoLevelSubjectId?: number; //	二级科目id
    channelSource?: number; // 渠道来源 高顿：100537564 上岸鸭公考：100537563
    lucaId?: number; //	lucaId
    pageSize: number; // 每页数量 默认20
    pageNum: number; //	当前页码
    questionType?: 0 | 1; // 0:问题 1:知识切片
}) => Http.get<IPageResponse<IMyQuestionItem>>('/athena/api/v1/front/luca-ask/collect/list', params);

// 收藏问题
export const collect_conversation_by_ask_id = (params: { ask_id: number }) =>
    Http.post('/carefree/front/ask/collect/save', params, { needToastError: false });

/**
 * luca的会话收藏
 */
export const collect_conversation_of_luca = async (params: {
    /**
     * 详情中的主键id
     */
    id?: number;
    /**
     * 详情中的Qa对Id
     */
    qaId?: string;
    /**
     * 知识点切片的记录id
     */
    recordId?: string;
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number;
    /**
     * 是否收藏
     */
    collectFlag: boolean;
}) => Http.post('/athena/api/v1/front/luca-ask/collect/save', params);
